<script setup lang="ts">
const accessSteps = [
  {
    number: '01',
    title: '注册账号',
    desc: '完成商户账号注册，提交基础资料。',
  },
  {
    number: '02',
    title: '商品配置',
    desc: '设置商品采购价格，在发布时配置自动发货',
  },
  {
    number: '03',
    title: '自动发货',
    desc: '平台下单成功，系统自动完成发货处理',
  },
  {
    number: '04',
    title: '数据统计',
    desc: '充值成功，实时更新订单数据，实时对账',
  },
]
</script>

<template>
  <div class="access-flow">
    <div
      v-for="(step, index) in accessSteps"
      :key="step.number"
      class="access-flow__item"
    >
      <div class="access-flow__head">
        <span class="access-flow__number">{{ step.number }}</span>
        <span class="access-flow__line"></span>
      </div>
      <h3>{{ step.title }}</h3>
      <p>{{ step.desc }}</p>
    </div>
  </div>
</template>

<style scoped lang="scss">
.access-flow {
  display: flex;
  width: 100%;
  padding: 8px 0 74px;

  &__item {
    position: relative;
    flex: 1 1 0;
    min-width: 0;
    padding-right: 26px;
  }

  &__head {
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 13px;
  }

  &__number {
    flex-shrink: 0;
    color: #ff7440;
    font-size: 48px;
    font-weight: 700;
    line-height: 1;
    letter-spacing: 0;
  }

  &__line {
    position: relative;
    flex: 1;
    height: 1px;
    margin-left: 24px;
    background-image: linear-gradient(90deg, #ff7440 0 4px, transparent 4px 8px);
    background-size: 8px 1px;
    background-repeat: repeat-x;

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      border: 2px solid #ff7440;
      background: #fff;
      transform: translate(-50%, -50%);
    }
  }

  h3 {
    margin: 0 0 11px;
    color: #314052;
    font-size: 20px;
    font-weight: 700;
    line-height: 1.25;
  }

  p {
    max-width: 230px;
    margin: 0;
    color: #86a0bd;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.75;
  }
}

@media (max-width: 900px) {
  .access-flow {
    flex-direction: column;
    gap: 22px;
    padding-bottom: 34px;

    &__item {
      padding-right: 0;
    }

    &__line {
      display: none;
    }

    p {
      max-width: none;
    }
  }
}
</style>
